import styled from 'styled-components';
import OtpInput from 'react-otp-input';

const StyledOTP = styled.div`
  > div {
    gap: 12px;
    > div {
      width: 29px;
      height: 34px;
      border: 1px solid var(--text-color-1);
      input {
        width: 100% !important;
        border: none;
      }
    }
  }
`;
export default function OTP({
  value,
  onChange,
  className,
  isDisabled,
}: {
  value: string;
  onChange: (v: string) => void;
  className?: string;
  isDisabled?: boolean;
}) {
  return (
    <StyledOTP className={className}>
      <OtpInput
        value={value}
        onChange={(v: string) => {
          if (/^\d+$/.test(v) || v === '') onChange(v);
        }}
        numInputs={5}
        separator={<span />}
        isDisabled={isDisabled}
      />
    </StyledOTP>
  );
}
